import { platformsService } from "@/services/platforms";
import { eventsService } from "@/services/events";
import { request } from "@/plugins/request";
import {
  REQUEST_STATUS_AWAIT,
  REQUEST_STATUS_CONFIRMED,
  CONTEST_EVENTS,
  ORGANIZATION_FIELD_NAME,
  PLATFORM_FIELD_NAME,
} from "@/constants";

const LIMIT = 50;

const state = {
  selectedOrganization: null,
  organizationsPlatforms: {},
  selectedPlatform: null,
  loadPending: false,
  organizations: [],
  requests: [],
  eventsFields: {},
};

const mutations = {
  SET_ORGANIZATIONS(state, organizations) {
    state.organizations = organizations;
  },
  SET_REQUESTS(state, requests) {
    state.requests = [...state.requests, ...requests];
  },
  SET_SELECTED_ORGANIZATION(state, organization) {
    state.selectedOrganization = organization;
  },
  SET_ORGANIZATIONS_PLATFORMS(state, { orgId, platforms }) {
    state.organizationsPlatforms = {
      ...state.organizationsPlatforms,
      [orgId]: platforms,
    };
  },
  SET_SELECTED_PLATFORM(state, platform) {
    state.selectedPlatform = platform;
  },
  SET_LOAD_PENDING(state, value) {
    state.loadPending = value;
  },
  SET_EVENTS_FIELDS(state, fields) {
    state.eventsFields = fields;
  },
};

const actions = {
  async getOrganizations({ commit }, { userId }) {
    const { data } = await request({
      method: "GET",
      url: `/users/${userId}/organizations/`,
      params: { limit: 100 },
    });
    if (data.count) {
      commit("SET_ORGANIZATIONS", data.results);
      return data.results;
    }
  },
  async getRequest({ commit }, { id, userId }) {
    const { data } = await request({
      method: "GET",
      url: `/users/${userId}/requests/`,
      params: { event: id },
    });
    if (data.results.length) {
      const event = data.results[0];
      // Берем только заявки на модерации или согласованные
      if (
        event.status === REQUEST_STATUS_AWAIT ||
        event.status === REQUEST_STATUS_CONFIRMED
      ) {
        // this.requests.push(event);
        commit("SET_REQUESTS", [event]);
      }
    }
  },
  async getPlatforms({ commit }, { orgId }) {
    commit("SET_LOAD_PENDING", true);
    let result = [];
    const params = {
      limit: LIMIT,
      offset: 0,
      subject: true,
      organization_id: orgId,
      deleted: false,
    };

    try {
      const firstPart = await platformsService.getPlatforms({ orgId, params });
      result = [...firstPart.data.results];

      if (firstPart.count > LIMIT) {
        const pages = Math.ceil(firstPart.data.count / LIMIT);

        const requests = Array.from({ length: pages - 1 }, (_, idx) => {
          const page = idx + 1;
          const prms = { ...params, offset: page * LIMIT };
          return platformsService.getPlatforms({ orgId, prms });
        });

        const responses = await Promise.all(requests);

        const list = responses.reduce((acc, response) => {
          return [...acc, ...response.data.results];
        }, []);

        result = [...result, ...list];
      }
    } catch (error) {
      console.log("error", error);
    }

    commit("SET_ORGANIZATIONS_PLATFORMS", { orgId, platforms: result });
    commit("SET_LOAD_PENDING", false);
    return result;
  },
  async getEventsFields({ state, commit }) {
    if (Object.keys(state.eventsFields).length) return;
    try {
      const ids = Object.values(CONTEST_EVENTS);
      const data = await Promise.all(
        ids.map((id) => eventsService.getEvent(id))
      );

      const fields = data.reduce((acc, res) => {
        const flds = res.data.fields;
        if (!Array.isArray(flds)) return acc;
        const neededFields = flds.reduce((acc, f) => {
          if (f.name === ORGANIZATION_FIELD_NAME) {
            acc[ORGANIZATION_FIELD_NAME] = f.id;
          }
          if (f.name === PLATFORM_FIELD_NAME) {
            acc[PLATFORM_FIELD_NAME] = f.id;
          }
          return acc;
        }, {});
        if (Object.keys(neededFields).length) {
          acc[res.data.id] = neededFields;
        }

        return acc;
      }, {});

      commit("SET_EVENTS_FIELDS", fields);
    } catch (error) {
      console.log("error");
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
